import { useEffect } from "react";

const BlogFaqs = () => {
  useEffect(() => {
    const faqs = document.querySelectorAll(".schema-faq-question");

    faqs.forEach((faq) => {
      const answer = faq.nextElementSibling;
      if (answer && answer.classList.contains("schema-faq-answer")) {
        answer.style.maxHeight = "0";
        answer.style.overflow = "hidden";
        answer.style.transition = "max-height 0.5s ease, padding 0.3s ease";
        answer.style.padding = "0 20px";
      }

      faq.addEventListener("click", () => {
        faqs.forEach((otherFaq) => {
          const otherAnswer = otherFaq.nextElementSibling;
          if (otherAnswer && otherAnswer.classList.contains("schema-faq-answer")) {
            if (otherAnswer !== answer) {
              otherAnswer.classList.remove("expanded");
              otherFaq.classList.remove("expanded");
              otherAnswer.style.maxHeight = "0";
              otherAnswer.style.padding = "0 20px";
            }
          }
        });

        // Toggle clicked answer
        if (!answer.classList.contains("expanded")) {
          answer.classList.add("expanded");
          faq.classList.add("expanded");
          answer.style.maxHeight = answer.scrollHeight + "px";
          answer.style.padding = "15px 20px";
        } else {
          answer.classList.remove("expanded");
          faq.classList.remove("expanded");
          answer.style.maxHeight = "0";
          answer.style.padding = "0 20px";
        }
      });
    });

    // Cleanup
    return () => {
      faqs.forEach((faq) => {
        faq.replaceWith(faq.cloneNode(true));
      });
    };
  }, []);

  return null;
};

export default BlogFaqs;
